import clsx from 'clsx';
import { Button } from 'antd';
import { ButtonProps, ButtonType } from 'antd/lib/button/button';

import  './common-button.module.scss';

type ButtonSpace = 'space-small' | 'space-medium' | 'space-large';

interface CommonButtonProps extends ButtonProps {
  variant?: keyof typeof idByVariant;
  space?: ButtonSpace;
  textBold?: boolean;
  reverseIcon?: boolean;
  customWidth?: boolean;
  idKey?:string;
}

const idByVariant: Record<ButtonType, string> = {
  primary: 'var-primary-button',
  default: 'var-default-button',
  ghost: '',
  dashed: 'var-dashed-button',
  link: '',
  text: '',
};
const classBySpace: Record<ButtonSpace, string> = {
  'space-small': 'space-small',
  'space-medium': 'space-medium',
  'space-large': 'space-large',
};

export const CommonButton = ({
  variant = 'primary',
  space = 'space-medium',
  textBold = true,
  customWidth = false,
  reverseIcon = false,
  idKey,
  ...props
}: CommonButtonProps) => {
  return (
    <Button
      {...props}
      id={idByVariant[variant]+(idKey||'')}
      type={variant}
      className={clsx(
        idByVariant[variant],
        props.className,
        classBySpace[space],
        textBold ? 'font-semibold' : 'font-medium',
        customWidth ? 'custom-width' : '',
        { 'reverse-icon': reverseIcon },
      )}
    />
  );
};
